<span class="loading-attribute" [matTooltip]="tooltip" [matTooltipShowDelay]="700">
  <i *ngIf="icon" [class]="icon"></i>
  <span *ngIf="value !== undefined">{{ value }}</span>
  <span *ngIf="value === undefined" class="loading-dots"></span>
</span>
